/* Shared display formatters. Used by both the public site and the dashboard,
   so they live outside either store. */

/** Compact naira, for dense tables and stat tiles: ₦9.8m, ₦640,000. */
export const naira = (n: number) =>
  "₦" +
  (n >= 1_000_000
    ? (n / 1_000_000).toFixed(n % 1_000_000 === 0 ? 0 : 1) + "m"
    : n.toLocaleString("en-NG"))

/** Full naira, for anything someone might reconcile against an invoice. */
export const nairaFull = (n: number) => "₦" + n.toLocaleString("en-NG")

export const fmtDate = (iso: string) =>
  new Date(iso).toLocaleDateString("en-GB", {
    day: "numeric",
    month: "short",
    year: "numeric",
  })

export const fmtDateShort = (iso: string) =>
  new Date(iso).toLocaleDateString("en-GB", { day: "numeric", month: "short" })

/** "Sukan Pace Ltd" -> "SP". Skips articles and company suffixes. */
export function initials(name: string) {
  const skip = /^(the|a|an|ltd|limited|plc|inc|llc|nigeria)$/i
  return name
    .split(/\s+/)
    .filter((w) => /^[A-Za-z]/.test(w) && !skip.test(w))
    .slice(0, 2)
    .map((w) => w[0]!.toUpperCase())
    .join("")
}
